class LazyVideo extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: contents;

        opacity: 0;
      
        transition: opacity 0.5s ease;
      }
      :host([loaded]) {
        opacity: 1;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    if (
      window.innerWidth > 768 ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}